import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMain } from 'vuetify/lib/components/VMain';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    on: {
      click: _vm.shutCart
    }
  }, [_c(VApp, [_c("ScheduledMaintenanceAlert"), _vm.isMaintenanceMode ? _c(VAppBar, {
    staticClass: "app-header",
    attrs: {
      height: "126px",
      "max-height": "126px",
      elevation: "0"
    }
  }, [_c("menu-component", {
    attrs: {
      logged: true
    }
  }), _c("div", {
    staticClass: "header-utils"
  }, [_c(VMenu, {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c("img", _vm._g({
          staticClass: "profile-img",
          attrs: {
            src: require("@/assets/images/icon_profil_white.svg"),
            alt: ""
          }
        }, on))];
      }
    }], null, false, 945513387)
  }, [_c(VList, [_vm._l(_vm.menus, function (m) {
    return _c(VListItem, {
      key: m.id
    }, [_c(VListItemContent, [_c("router-link", {
      staticClass: "router-link",
      attrs: {
        to: _vm.menuAction(m.route, m.tab)
      }
    }, [_c("span", {
      staticClass: "header-profile-menu-item"
    }, [_vm._v(_vm._s(m.label.toUpperCase()))]), m.route === "userProfile" && m.tab === "profile" && (_vm.isUserBuyerGroup(_vm.loggedUserData) || _vm.loggedUserData.isHolding) ? [_c("br"), _c("span", {
      staticClass: "text-italic text-capitalize"
    }, [_vm._v(_vm._s(m.status))])] : _vm._e()], 2)], 1)], 1);
  }), _c(VListItem, [_c(VListItemContent, [_c("span", {
    staticClass: "router-link",
    on: {
      click: function click($event) {
        return _vm.disconnectUser();
      }
    }
  }, [_c("span", {
    staticClass: "header-profile-menu-item"
  }, [_vm._v("SIGN OUT")])])])], 1)], 2)], 1), _vm.buyer ? _c("div", {
    staticClass: "cart-img",
    attrs: {
      id: [_vm.cartDisabled && "cart-disabled"]
    },
    on: {
      click: _vm.showCart
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/icons/cart.svg"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "cart-img-label"
  }, [_vm._v(" " + _vm._s(_vm.nbItems) + " item" + _vm._s(_vm.nbItems > 1 ? "s" : null) + " "), _vm.nbItems > 0 ? _c("div", {
    staticClass: "label-timelapse"
  }, [_vm.isCountdownElapsed ? _c("span", [_c("i", {
    staticClass: "fas fa-exclamation-circle"
  }), _vm._v(" 00:00:00 ")]) : _c("span", [_vm._v(_vm._s(_vm.timelapse))])]) : _vm._e()])]) : _vm._e()], 1)], 1) : _vm._e(), _c(VMain, [_c(VContainer, {
    attrs: {
      fluid: ""
    }
  }, [_c("router-view", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  }), _c("div", {
    on: {
      mouseover: function mouseover($event) {
        _vm.hoverCart = true;
      },
      mouseleave: function mouseleave($event) {
        _vm.hoverCart = false;
      }
    }
  }, [_c("cart", {
    key: "cart_" + _vm.cart,
    staticClass: "cart",
    class: [_vm.cart ? "cart-shown" : "cart-hidden"],
    attrs: {
      loggedUserData: _vm.loggedUserData,
      areAllItemsAddedToCart: _vm.areAllItemsAddedToCart
    },
    on: {
      shutCart: _vm.shutCart
    }
  })], 1)], 1)], 1), _c("loading", {
    attrs: {
      active: _vm.loading.isLoading,
      "can-cancel": _vm.loading.canCancel,
      color: _vm.loading.color,
      "background-color": _vm.loading.bgColor,
      opacity: _vm.loading.opacity,
      "is-full-page": _vm.loading.fullPage,
      loader: _vm.loading.loader
    },
    on: {
      "update:active": function updateActive($event) {
        return _vm.$set(_vm.loading, "isLoading", $event);
      }
    }
  }), _vm.isMaintenanceMode ? _c("footer-component", {
    attrs: {
      isTerms: true
    }
  }) : _vm._e(), _c(VDialog, {
    attrs: {
      persistent: "",
      width: "40rem"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.modalWarningShown,
      callback: function callback($$v) {
        _vm.modalWarningShown = $$v;
      },
      expression: "modalWarningShown"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    staticStyle: {
      "justify-content": "center"
    }
  }, [_vm._v(_vm._s(_vm.modalWarning.title))]), _c(VCardText, {
    staticClass: "modalWarningContents"
  }, _vm._l(_vm.modalWarning.contents, function (content, i) {
    var _content$class;
    return _c("p", {
      key: "modalWarningcontent-" + i,
      class: (_content$class = content.class) !== null && _content$class !== void 0 ? _content$class : "errorLabel"
    }, [_vm._v(" " + _vm._s(content.text) + " ")]);
  }), 0), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click() {
        _vm.modalWarningShown = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.modalWarning.buttonText) + " ")])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };